/* Ekore ACT icon set — 1.75px stroke, lucide-flavoured, all inline SVG. */
/* Ported from the design handoff, then typed. */

import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

const strokeDefaults: IconProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

export function EkoreLogo({ variant = 'color', height = 32 }: { variant?: 'color' | 'white' | 'mark'; height?: number }) {
  const src =
    variant === 'white' ? '/assets/logo-ekore-white.svg'
    : variant === 'mark' ? '/assets/logo-ekore.svg'
    : '/assets/logo-ekore.svg'
  return (
    <img
      src={src}
      alt="Ekore — Digital Twin Solution"
      className="brand-logo"
      style={{ height: `${height}px`, width: 'auto' }}
    />
  )
}

export function Plug(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M9 2v6" /><path d="M15 2v6" />
      <path d="M6 8h12v4a6 6 0 0 1-6 6 6 6 0 0 1-6-6V8z" />
      <path d="M12 18v4" />
    </svg>
  )
}

export function Flame(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 17c1.5 0 2.5-1 2.5-2.5 0-.5-.1-1-.4-1.5 1.3-.2 2.4-1.2 2.4-2.6 0-2.2-2.3-2.8-2.3-5.8 0-1.1-.5-1.6-.7-2.1-2 0-3.7 1.4-4.2 3.2-.4 1.3-.5 2.6-.5 4C7.8 10.8 7 12 7 14c0 1.1.6 2.3 1.5 2.5z" />
    </svg>
  )
}

export function Snowflake(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M12 2v20M2 12h20M4.93 4.93l14.14 14.14M19.07 4.93L4.93 19.07" />
      <path d="M9 4l3-2 3 2M9 20l3 2 3-2M4 9l-2 3 2 3M20 9l2 3-2 3" />
    </svg>
  )
}

export function Fan(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  )
}

export function Utensils(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M3 2v7c0 1.1.9 2 2 2h2V2M5 2v20M20 14v7M20 14c-1.66 0-3-1.57-3-3.5s1.34-4.5 3-4.5" />
    </svg>
  )
}

export function Grill(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <rect x="3" y="6" width="18" height="10" rx="2" />
      <path d="M3 10h18M3 13h18M7 16v4M17 16v4" />
    </svg>
  )
}

export function Wind(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2" />
      <path d="M9.6 4.6A2 2 0 1 1 11 8H2" />
      <path d="M12.6 19.4A2 2 0 1 0 14 16H2" />
    </svg>
  )
}

export function Zap(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  )
}

export function Box(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
      <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
  )
}

export function Clock(props: IconProps) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
    </svg>
  )
}

export function X(props: IconProps) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  )
}

export function ChevronUpDown(props: IconProps) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <polyline points="8 9 12 5 16 9" /><polyline points="8 15 12 19 16 15" />
    </svg>
  )
}

export function ChevronLeft(props: IconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" {...strokeDefaults} strokeWidth={2} {...props}>
      <polyline points="15 18 9 12 15 6" />
    </svg>
  )
}

export function ChevronRight(props: IconProps) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" {...strokeDefaults} strokeWidth={2} {...props}>
      <polyline points="9 18 15 12 9 6" />
    </svg>
  )
}

export function Check(props: IconProps) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...strokeDefaults} strokeWidth={2} {...props}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  )
}

export function Alert(props: IconProps) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M10.3 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  )
}

export function WifiOff(props: IconProps) {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <line x1="1" y1="1" x2="23" y2="23" />
      <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
      <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
      <path d="M10.71 5.05A16 16 0 0 1 22.58 9" />
      <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
      <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
      <line x1="12" y1="20" x2="12.01" y2="20" />
    </svg>
  )
}

export function Gauge(props: IconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="m12 14 4-4" /><path d="M3.34 19a10 10 0 1 1 17.32 0" />
    </svg>
  )
}

export function Inbox(props: IconProps) {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </svg>
  )
}

export function Refresh(props: IconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <polyline points="23 4 23 10 17 10" />
      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
    </svg>
  )
}

export function Sun(props: IconProps) {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  )
}

export function CloudSun(props: IconProps) {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M12 2v2M5.22 5.22l1.42 1.42M2 12h2M17.66 6.34l1.41-1.41M20 12h2" />
      <path d="M15.95 11a5 5 0 0 0-9.9 1H6a4 4 0 0 0 0 8h10a4 4 0 0 0 0-8h-.05z" />
    </svg>
  )
}

export function Cloud(props: IconProps) {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
    </svg>
  )
}

export function CloudRain(props: IconProps) {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25" />
      <line x1="8" y1="19" x2="8" y2="21" /><line x1="8" y1="13" x2="8" y2="15" />
      <line x1="16" y1="19" x2="16" y2="21" /><line x1="16" y1="13" x2="16" y2="15" />
      <line x1="12" y1="21" x2="12" y2="23" /><line x1="12" y1="15" x2="12" y2="17" />
    </svg>
  )
}

export function CloudSnow(props: IconProps) {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25" />
      <line x1="8" y1="16" x2="8.01" y2="16" /><line x1="8" y1="20" x2="8.01" y2="20" />
      <line x1="12" y1="18" x2="12.01" y2="18" /><line x1="12" y1="22" x2="12.01" y2="22" />
      <line x1="16" y1="16" x2="16.01" y2="16" /><line x1="16" y1="20" x2="16.01" y2="20" />
    </svg>
  )
}

export function Cloudy(props: IconProps) {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9z" />
    </svg>
  )
}

export function Thermometer(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4 4 0 1 0 5 0z" />
    </svg>
  )
}

export function Droplet(props: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" />
    </svg>
  )
}

export function Lock(props: IconProps) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  )
}

export function LogOut(props: IconProps) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" {...strokeDefaults} {...props}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  )
}

/** Icon keyed by the DeviceIcon name returned by the server. */
import type { DeviceIcon } from './types/device'

const DEVICE_ICONS: Record<DeviceIcon, (p: IconProps) => React.JSX.Element> = {
  Fan, Flame, Snowflake, Utensils, Grill, Wind, Zap, Box, Plug,
}

export function DeviceIconSvg({ name, ...props }: { name: DeviceIcon } & IconProps) {
  const Component = DEVICE_ICONS[name] ?? Plug
  return <Component {...props} />
}
